"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSource = exports.MfaStatus = void 0;
var MfaStatus;
(function (MfaStatus) {
    MfaStatus["unset"] = "unset";
    MfaStatus["pending"] = "pending";
    MfaStatus["active"] = "active";
    MfaStatus["deactivated"] = "deactivated";
})(MfaStatus || (exports.MfaStatus = MfaStatus = {}));
var UserSource;
(function (UserSource) {
    UserSource["KPT"] = "kpt-web";
    UserSource["HELSANA"] = "helsana-web";
    UserSource["VISANA"] = "visana-web";
    UserSource["PORTAL"] = "portal-web";
    UserSource["COMPASSANA"] = "compassana-web";
    UserSource["OKK"] = "okk-web";
})(UserSource || (exports.UserSource = UserSource = {}));
//# sourceMappingURL=mfa.js.map